import apolloClient from '../../apollo-client'
import { GET_NEWS_BY_ID } from '../../graphql/news'
import { NewsFull } from '../../types/News'
import classes from './MobileNewsDetail.module.scss'
import PageHeader from '../../components/pageHeader/PageHeader'
import Link from 'next/link'
import HeroImage from '../../components/ui/image/HeroImage'
import { GetStaticProps } from 'next'
import NewsDetailHead from '../../components/heads/NewsDetailHead'
import { useRouter } from 'next/router'
import { ListBlankLoadMask } from '../../components/ui/ListBlankLoadMask'

interface Props {
  data: NewsFull
}
export default function NewsDetail({ data }: Props) {
  const router = useRouter()

  if (router.isFallback) {
    return <ListBlankLoadMask />
  }

  return (
    <>
      <NewsDetailHead
        title={data.title}
        body={data.body}
        imageUrl={data.image?.Location}
      />
      <PageHeader bucket="truck-drivers-news/hero" isHold={false} />
      <div className="flex flex-col justify-center items-center w-full px-[20px] bg-[#182540]">
        <div className="flex w-full max-w-[1200px] py-[8px] px-[0] justify-end max-[992px]:flex-col">
          <div className="flex text-white">
            <Link
              type="button"
              href="/truck-drivers-news"
              className={` ${classes.backButton} cursor-pointer px-[10px] py-[3px] text-center text-[18px] font-semibold uppercase min-w-[88px] h-[38px] tracking-[1px] border-[1px] border-solid border-[#777] rounded max-[992px]:w-full`}>
              Back to results
            </Link>
          </div>
        </div>
      </div>
      <section className={`max-w-[1200px] mx-auto ${classes.newsArticle}`}>
        <HeroImage
          srcUrl={data?.image?.Location}
          alt={`${data.title} image`}
          height={1200}
          width={2400}
        />
        <div className={`py-[10px] ${classes.newsBody}`}>
          <h2
            className={` ${classes.newsTitle} text-[#6f6f6f] font-semibold text-[32px] mt-[25px] mb-[34px] text-left z-[1]`}>
            {data.title}
          </h2>

          <div
            className={` ${classes.newsData} font-normal text-[16px] text-[#6f6f6f] columns-3 gap-[30px] leading-[1.5] text-justify break-words`}
            dangerouslySetInnerHTML={{
              __html: data.body || ''
            }}></div>
        </div>
      </section>
    </>
  )
}

export async function getStaticPaths() {
  return { paths: [], fallback: true }
}

export const getStaticProps: GetStaticProps = async (context) => {
  const id = context.params?.id
  try {
    const { data } = await apolloClient.query({
      query: GET_NEWS_BY_ID,
      variables: { id }
    })

    const news = data.getNewsById
    if (!news) {
      throw new Error('News not found')
    }
    return {
      revalidate: 60 * 5,
      props: {
        data: news
      }
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(`error while executing getStaticProps of news ${id}`, error)
    return {
      notFound: true
    }
  }
}
